"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../../configuration");
var NewConditionsAdapter = (function () {
    function NewConditionsAdapter(input, tariffConditionId) {
        if (input) {
            this.setDataFromInput(input);
        }
        if (!tariffConditionId && _.get(input, "online")) {
            tariffConditionId = "OnlineMedium";
            this.vat = input.vat;
            this.agencyCommission = input.agencyCommission;
            this.cashDiscount = input.cashDiscount;
            this.gross = input.gross;
        }
        if (tariffConditionId) {
            this.setConditionsAccordingToTariffConditionId(input, tariffConditionId);
        }
    }
    NewConditionsAdapter.prototype.setDataFromInput = function (input) {
        this.gross = input.gross;
        this.agencyCommission = input.agencyCommission;
        this.cashDiscount = input.cashDiscount;
        this.vat = input.vat;
        this.rateCard = input.rateCard;
    };
    NewConditionsAdapter.prototype.setConditionsAccordingToTariffConditionId = function (oldConditions, tariffConditionId) {
        switch (tariffConditionId) {
            case "OnlineMedium":
            case "DigitalMedium":
            case "MobileMedium":
                this.online = oldConditions.online;
                break;
            case "Outdoor":
            case "":
                break;
            case null:
            case undefined:
                configuration_1.PlanConfiguration.logger.warn("WARNING! tariffConditionId is null or undefined!");
                break;
            default:
                configuration_1.PlanConfiguration.logger.error("Unknown medium");
                configuration_1.PlanConfiguration.logger.error(tariffConditionId);
        }
    };
    return NewConditionsAdapter;
}());
exports.NewConditionsAdapter = NewConditionsAdapter;
//# sourceMappingURL=NewConditionsAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/NewConditionsAdapter.js
// module id = 37
// module chunks = 0